export type TenantStatus = 'Active' | 'Suspended' | 'Deactivated' | 'Deleted'

/** AXF-1274: Identity's label for the workspace's licence (D9), as the staff API names it. The one list. */
export const LICENCE_KINDS = ['Customer', 'Internal', 'Partner'] as const
export type LicenceKind = (typeof LICENCE_KINDS)[number]

export interface Tenant {
  id: string
  name: string
  slug: string
  status: TenantStatus
  description?: string
  plan?: string
  maxUsers?: number
  createdAt: string
  updatedAt?: string
  licenceContractId?: string
  licenceKind?: LicenceKind
  /** Auxalia Identity deleted the linked licence; members are locked out until staff link the right one. */
  licenceDeleted?: boolean
}

/** AXF-1280: what Auxalia Identity says about a contract staff are about to link. */
export interface ContractLookup {
  contractId: string
  status: string
  endDate: string | null
  blockedAt: string | null
  /** True when linking will lock the workspace (ended/blocked while the licence lock is on). */
  lockApplies: boolean
  /** AXF-1271 D7: when the licence's grace ends (ISO), set only while it is in grace and the licence lock is on. */
  graceEndsAt?: string | null
}

export interface MovePersonNotOnLicence {
  userId: string
  displayName: string | null
  email: string
}

export interface MovePeopleSummary {
  readFailed: boolean
  liveMembers: number
  notOnLicence: MovePersonNotOnLicence[]
  removalsOn: boolean
  buyerOnly: boolean
  held: boolean
  /** The new contract's status maps to Active, which removals need. */
  newLicenceActive: boolean
}

export interface ContractMoveLookup {
  fromContractId: string
  to: ContractLookup
  people: MovePeopleSummary
}
